import service from "./service";

const prefix = "/common-uam";

export const getActiveUserList = () =>
  service.get(`${prefix}/users/active-user-dropdown`);

export const getActiveGroupList = () =>
  service.get(`${prefix}/groups/active-group-dropdown`);

export const getActiveRoleList = () =>
  service.get(`${prefix}/roles/active-role-dropdown`);

export const getUsersAndGroupsListByPrivilege = (data: {
  module: string;
  domain: string;
  privilege: string;
}) =>
  service.post(`${prefix}/resources/privilege/process/users-and-groups`, data);

export const getUserSettings = () =>
  service.get(`${prefix}/session/user-settings`);
